import { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Neubau from './pages/Neubau';
import Umbau from './pages/Umbau';
import Sanierung from './pages/Sanierung';
import Referenzen from './pages/Referenzen';
import ProjectDetail from './pages/ProjectDetail';
import Karriere from './pages/Karriere';
import UeberUns from './pages/UeberUns';
import Anfrage from './pages/Anfrage';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import AGB from './pages/AGB';
import Leistungen from './pages/Leistungen';
import NotFound from './pages/NotFound';
import CookieConsent from './components/common/CookieConsent';

// Lazy-load admin (separate bundle)
const AdminApp = lazy(() => import('./admin/AdminApp'));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Disable browser scroll restoration so refresh always lands at top
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Admin routes — separate theme, no public layout */}
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Laden...</div>}>
              <AdminApp />
            </Suspense>
          }
        />

        {/* Public routes */}
        <Route
          path="/*"
          element={
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/leistungen" element={<Leistungen />} />
                  <Route path="/neubau" element={<Neubau />} />
                  <Route path="/umbau" element={<Umbau />} />
                  <Route path="/sanierung" element={<Sanierung />} />
                  <Route path="/referenzen" element={<Referenzen />} />
                  <Route path="/referenzen/:id" element={<ProjectDetail />} />
                  <Route path="/karriere" element={<Karriere />} />
                  <Route path="/uber-uns" element={<UeberUns />} />
                  <Route path="/anfrage" element={<Anfrage />} />
                  <Route path="/impressum" element={<Impressum />} />
                  <Route path="/datenschutz" element={<Datenschutz />} />
                  <Route path="/agb" element={<AGB />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Layout>
              <CookieConsent />
            </ThemeProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
